import { PROJECT_PAGE, PROJECT_PATH_PATTERN } from '@townsquare/config/routes';
import { createSiteRoute } from '@townsquare/router/create-route';
import { SiteHomePageRoute } from '@townsquare/router/route-types';

export const projectRoute: SiteHomePageRoute = createSiteRoute({
	exact: true,
	name: PROJECT_PAGE,
	path: PROJECT_PATH_PATTERN,
	capabilities: ['projects_app:access'],
	subproduct: 'townsquare-projects',
	enableRestrictedFallback: true,
});
